<template>
  <v-data-table
    :headers="headers"
    :items="transactions"
    :loading="false"
    class="table-layout pa-4 pt-0"
    hide-default-footer
    fixed-header
    :height="tableHeight"
  >
    <template v-slot:item.stt="{ item }">
      {{ item.stt || '-' }}
    </template>
    <template v-slot:item.orderCode="{ item }">
      <b class="cursor-pointer" @click="clickDetailOrder(item.order_id)">{{ item.order_code }}</b>
    </template>
    <template v-slot:item.receiptCode="{ item }">
      <b class="cursor-pointer" @click="clickDetailOrder(item.order_id)">{{ item.receipt_code }}</b>
    </template>
    <template v-slot:item.fundTransferId="{ item }">
      <b>{{ item.fund_transfer_id }}</b>
    </template>
    <template v-slot:item.paidAt="{ item }">
      {{ item.created_at_payment }}
    </template>
    <template v-slot:header.createdAt>
      <div class="created-at-header">Ngày tạo</div>
    </template>
    <template v-slot:item.createdAt="{ item }">
      <div class="created-at-cell">{{ item.created_at_qr_code }}</div>
    </template>
    <template v-slot:header.amount>
      <div class="text-left">Số tiền</div>
    </template>
    <template v-slot:item.amount="{ item }">
      <div class="text-right">{{ formatCurrency(item.amount) }}</div>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        :color="getStatusColor(item.status)"
        small
        dark
      >
        {{ getStatusText(item.status) }}
      </v-chip>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'

export default {
  name: 'QrTransactionTable',
  props: {
    transactions: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      tableHeight: 'calc(100vh - 310px)',
      headers: [
        { text: 'STT', value: 'stt', sortable: false, width: '80px', align: 'center' },
        { text: 'Mã đơn hàng', value: 'orderCode', sortable: false },
        { text: 'Mã phiếu thu', value: 'receiptCode', sortable: false },
        { text: 'Mã giao dịch', value: 'fundTransferId', sortable: false },
        { text: 'Số tiền', value: 'amount', width: '130px', sortable: false, align: 'right' },
        { text: 'Ngày tạo', value: 'createdAt', sortable: false, align: 'left' },
        { text: 'Ngày thanh toán', value: 'paidAt', sortable: false, align: 'left' },
        { text: 'Trạng thái', value: 'status', sortable: false, align: 'center' },
      ],
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    formatCurrency(amount) {
      if (!amount) return '0'
      const num = parseInt(amount)
      return num.toLocaleString('it-IT') + ' đ'
    },
    getStatusColor(status) {
      const statusMap = {
        'Successful': 'green',
        'in_progress': 'orange',
        'final_failed': 'red',
      }
      return statusMap[status] || 'grey'
    },
    getStatusText(status) {
      const statusMap = {
        'Successful': 'Thành công',
        'in_progress': 'Đang xử lý',
        'final_failed': 'Thất bại',
      }
      return statusMap[status] || status
    },

    clickDetailOrder(orderId) {
      const route = this.$router.resolve({
        name: 'OrderDetail',
        params: {
          id: orderId,
        },
        query: {
          orderList: true,
        },
      });
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.created-at-header {
  padding-left: 32px;
}
.created-at-cell {
  padding-left: 32px;
}
</style>
